module.exports = __webpack_public_path__ + "static/media/Neo.97a0ca56.png";